﻿import Carousel from './lib/carousel';
import SwipeDetect from './lib/swipe';
import Tab from './lib/tab';
import Util from './lib/util'
import sessionTimeout from './lib/bootstrap-session-timeout.js';

/**
 * --------------------------------------------------------------------------
 * Bootstrap (v4.3.1): main.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * --------------------------------------------------------------------------
 */

(() => {
    if (typeof $ === 'undefined') {
        throw new TypeError('Bootstrap\'s JavaScript requires jQuery. jQuery must be included before Bootstrap\'s JavaScript.')
    }

    const version = $.fn.jquery.split(' ')[0].split('.')
    const minMajor = 1
    const ltMajor = 2
    const minMinor = 9
    const minPatch = 1
    const maxMajor = 4

    if (version[0] < ltMajor && version[1] < minMinor || version[0] === minMajor && version[1] === minMinor && version[2] < minPatch || version[0] >= maxMajor) {
        throw new Error('Bootstrap\'s JavaScript requires at least jQuery v1.9.1 but less than v4.0.0')
    }

    function equalize($thisObj) {
        var maxHeight = 0;

        $thisObj.each(function () {
            if ($(this).height() > maxHeight) { maxHeight = $(this).height(); }
        });

        if (maxHeight > 0) $thisObj.height(maxHeight);
    }

    //Equalise carousel slide height
    if ($('.carousel.slide').length > 0 && $('.carousel.slide').is(':visible')) {
        $('.carousel.slide').each(function () {
            var $thisSlide = $(this);

            if ($thisSlide.find('.carousel-item').length > 1) {
                equalize($thisSlide.find('.carousel-item'));

                SwipeDetect($thisSlide[0], (direction) => {
                    if (direction == 'left') $thisSlide.carousel('next');
                    if (direction == 'right') $thisSlide.carousel('prev');
                }, 50);
            } else {
                $thisSlide.find('.carousel-control-prev,.carousel-control-next,.carousel-indicators').hide();
            }
        })

    }

    //Allow burger bar menu to close on page click
    $('body').on('click', 'main, footer', function () {
        if ($('#menuToggle input[type=checkbox]').is(':visible') && $('#menuToggle input[type=checkbox]').prop('checked')) $('#menuToggle input[type=checkbox]').prop('checked', false);
    });

    //Shorten login button text for mobile view
    let $loginBtn = $('.main-header-login .login-btn');
    if ($loginBtn.length > 0) {
        let loginText = '';
        $loginBtn.each((key, thisBtn) => {
            loginText = $(thisBtn).text().trim().split(' ');
            if (loginText.length == 2 && loginText[1] == 'się') $(thisBtn).html(loginText[0]).append($('<span>').addClass('d-none d-lg-inline').text(' ' + loginText[1]));
        })
    }

    //Allow header sub menus to be accessed via keyboard
    $('.nav-main-list').on('keydown' + ($(window).outerWidth() < 992 ? '' : ' mouseover mouseout'), '.dropdown', function (e) {
        const $dropDown = $(this);
        const $menuToggle = $dropDown.find('.dropdown-toggle');
        const $subMenu = $menuToggle.next('.dropdown-menu');

        if (e.key === 'Enter') {
            window.location.href = $menuToggle.attr('href');
        } else {
            let expand = false;
            if (e.type === 'mouseover' || e.type === 'mouseout') {
                expand = (e.type === 'mouseover');
            }
            if (e.key === ' ' || e.key === 'ArrowUp' || e.key === 'ArrowDown' || e.key === undefined) {
                e.preventDefault();
                if (e.key !== undefined) {
                    $dropDown.siblings().trigger('mouseout');
                    expand = $menuToggle.attr('aria-expanded') !== 'true';
                    if (!expand && (e.key === 'ArrowUp' || e.key === 'ArrowDown')) {
                        return false
                    }
                }
                $menuToggle.attr('aria-expanded', expand);
                $dropDown.toggleClass('open', expand);
                $subMenu.prop('hidden', !expand);
                if (expand && (e.key !== undefined)) {
                    $subMenu.find('a').first().focus();
                }
                if (!expand && (e.key !== undefined)) {
                    $menuToggle.focus();
                }
            }
        }
    });

    //Allow header sub menu options to be accessed via keyboard
    $('.nav-main-list > ul > li').on('keydown', 'a', function (e) {
        const $menuItems = $('.nav-main-list > ul > li > a');
        const index = $menuItems.index(this);

        switch (e.key) {
            case 'ArrowRight':
                e.preventDefault();
                $(this).attr('tabindex', '-1');
                const next = $menuItems.get(index + 1) || $menuItems.get(0);
                $(next).attr('tabindex', '0').focus();
                break;
            case 'ArrowLeft':
                e.preventDefault();
                $(this).attr('tabindex', '-1');
                const prev = $menuItems.get(index - 1) || $menuItems.get($menuItems.length - 1);
                $(prev).attr('tabindex', '0').focus();
        }
    });

    //Allow header sub menu options to be accessed via keyboard
    $('.nav-main-list').on('keydown', '.dropdown-menu a', function (e) {
        const $menuItems = $(this).closest('.dropdown-menu').find('a');
        const index = $menuItems.index(this);

        switch (e.key) {
            case 'ArrowDown':
                e.preventDefault();
                $(this).attr('tabindex', '-1');
                const next = $menuItems.get(index + 1) || $menuItems.get(0);
                $(next).attr('tabindex', '0').focus();
                break;
            case 'ArrowUp':
                e.preventDefault();
                $(this).attr('tabindex', '-1');
                const prev = $menuItems.get(index - 1) || $menuItems.get($menuItems.length - 1);
                $(prev).attr('tabindex', '0').focus();
                break;
            case 'Escape', 'Tab':
                const $subMenu = $(this).closest('.dropdown-menu');
                const $this = $subMenu.prev('.dropdown-toggle');
                $subMenu.prop('hidden', true);
                $this.attr('aria-expanded', 'false').focus();
        }
    });

    // ------ Google Analytics scripts started

    // GA4 Scripts for Onclick of tab link
    $('section.sec-tab a.nav-tab__link').click(function () {
        var action = $(this).html();
        var pageurl = $(location).attr('href');
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
            'event': 'gaevent',
            'category': 'Click Tab',
            'action': action,
            'label': pageurl
        });
    });

    //GA4 Scripts for Onclick of document download link
    $('a.box-with-border-link').on('click', function () {
        var label = $(this).text();
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
            'event': 'gaevent',
            'category': 'Download document',
            'label': label
        });
    });

    // GA Scripts for Onclick of Loan apply button
    $('form.calc-form a.js-calc-submit').click(function () {
        var label;
        var text = $(this).text();
        if ($('.calc-offer-details ul li a.calc-product-details').hasClass('active')) {
            label = $('.calc-offer-details ul li a.calc-product-details.active').text();
        }
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
            'event': 'gaevent',
            'category': 'Click button',
            'action': text,
            'label': label
        });
    });
    //Google Analytics Scripts ended here    

    if ($(".health-check-info").length == 1) {
        healthCheck().then((data) => {
        }).catch((error) => {
            console.log('health check - ' + error);
        });

        function healthCheck() {
            return new Promise((resolve, reject) => {
                $.ajax({
                    url: '/api/sitecore/widget/GetPartialHealthCheckComponent',
                    type: 'POST',
                    data: null,
                    success: function (data) {
                        $(".health-check-info").append(data.PartialView);
                        $('div.info-content .loading-screen').hide();
                    },
                    error: function (error) {
                        $(".health-check-info").append('<h3>Error!</h3>');
                        $('div.info-content .loading-screen').hide();
                    },
                })
            })
        }
    }

    //Add extra links to sticky bookmark at top
    if ($('.sub-nav').length > 0) {
        var distance = $('.sub-nav').offset().top;
        var mobDistance = 600;
        var $window = $(window);
        $window.scroll(function () {
            if (window.innerWidth < 992) {
                $('.sub-nav').toggleClass('top-of-page', $window.scrollTop() >= mobDistance);
            } else {
                $('.sub-nav').toggleClass('top-of-page', $window.scrollTop() >= distance);
            }
        });
    }
})()

export {
    Util,
    Carousel,
    Tab,
    sessionTimeout
}